import Card from '@zenbusiness/zui/Card';
import PageHeader from '@zenbusiness/zui/PageHeader';
import { superstyled } from '@zenbusiness/zui/styles';

export const Header = superstyled({
  tag: PageHeader,
  name: 'BusinessProfileSkeleton',
  slot: 'Header',
  styles: () => ({
    marginBottom: 0,
  }),
});

export const Content = superstyled({
  tag: Card,
  name: 'BusinessProfileSkeleton',
  slot: 'Content',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  }),
});
